module.exports = __webpack_public_path__ + "static/media/032.479fded4.jpg";